const React = require('react');

const withState = require('../../../../../../utils/withState');
const {path$, Link} = require('../../../../../../router');
const {links} = require('../../constants');

const Ripple = require('../../../../../dumb/Ripple');

module.exports = withState(() => {
  function isActive(link, path, strict) {
    return strict
      ? link === path
      : path.startsWith(link);
  }

  return (state, props) => {
    const {compactView, onClick: onClickHandler} = props;
    return (
      <div>
        {links.map((el, id) => {
          const {icon: IC, title, link, disabled, onClick, isStrict} = el;
          const active = isActive(link, state.path, isStrict);
          return (
            <Ripple
              key={id}
              component={disabled ? 'div' : Link}
              href={disabled ? null : (link || '')}
              className={
                `h52 rlv layoutRow aiC pv f18 lh16 fw3 cA3A7AC dn
                ml-30 pl30 (ml-15|pl15)@m (ml-100|pl100)@d3
                (ml0|pl0).compact
                (w16|h18|dB)>.icon
                (dB|fx1|ml14)>.text
                (cFDFDFD|fw7).active
                (fillWhite).active>.icon
                (jcC).compact
                (dN).compact>.text
                (o70):h:not[.active]
                `
                + (active ? ' active' : '')
                + (compactView ? ' compact' : '')
              }
              onClick={() => {
                onClick && onClick();
                onClickHandler && onClickHandler();
              }}
            >
              {IC && <IC className="icon" />}
              <span className="text">{title}</span>
              <span className="dB abs st50% xY-50% sr0 bs bcF0 bcl3e4044 b bl20 bv26 dn z-1 (sr-20|z0)<1.active" />
            </Ripple>
          )
        })}
      </div>
    )
  }
}, {
  path: path$,
})
